/**
 * [sc-49133] Titolo della colonna di destra del PDF: «Dettaglio ordine #37» o
 * «Dettaglio preventivo #37». È lo stesso id, perché un ordine è il preventivo
 * confermato. Senza id (non dovrebbe succedere: il PDF si genera dopo il
 * salvataggio) resta il titolo senza numero.
 *
 * Fuori da `generateQuotePdf.js` perché quello importa jsPDF e usa
 * `import.meta`, che jest non parsa: qui si testa davvero.
 */
export function titoloDettaglio(quote, isOrder) {
  const base = isOrder ? "Dettaglio ordine" : "Dettaglio preventivo";
  return quote?.id ? `${base} #${quote.id}` : base;
}
